import { PageProps } from 'gatsby'
import { useState } from 'react'
import moment from 'moment'
import { Info, SEO, Title } from 'components/common'
import { DayStatusCard } from 'components/bookings'
import DailyTable from './home/daily-table'
import MonthlyTable from './home/monthly-table'

export const Head = () => <SEO title="予約状況" />

const Index = (page: PageProps<Queries.Query>): JSX.Element => {
  const [viewDay, setViewDay] = useState<moment.Moment>(moment())
  const [dailyViewTable, setViewDailyTable] = useState(false)

  const handleDailyView = (date: moment.Moment) => {
    if (date) {
      setViewDay(date)
    }
  }

  return (
    <>
      <Info title="チェックマークは予約があることを表し、チェックマークがない場合は予約がないことを表します。">
        <Title>予約状況</Title>
      </Info>
      <DayStatusCard
        onChangeToDaily={setViewDailyTable}
        dailyView={dailyViewTable}
        viewDay={viewDay}
        handleDailyView={handleDailyView}
      >
        {dailyViewTable ? (
          <DailyTable currentDate={viewDay} page={page} />
        ) : (
          <MonthlyTable
            currentDate={viewDay}
            handleDailyView={handleDailyView}
            onChangeToDaily={setViewDailyTable}
            page={page}
          />
        )}
      </DayStatusCard>
    </>
  )
}

export default Index
